// import { SAFETYMESSAGEANDLOGO, ReduxActionType } from 'types';

import { Params, ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_SAFETY_MESSAGE_AND_LOGO_START: ReduxActionType;
  UPDATE_SAFETY_MESSAGE_AND_LOGO_START: ReduxActionType;
  UPDATE_SAFETY_MESSAGE_AND_LOGO_SUCCESS: ReduxActionType;
  UPDATE_SAFETY_MESSAGE_AND_LOGO_FAILURE: ReduxActionType;
  UPLOAD_LOGO_FAILURE: ReduxActionType;
};

export const SafetyMessageAndLogoActionTypes: ActionTypes = {
  FETCH_SAFETY_MESSAGE_AND_LOGO_START: '@@FETCH_SAFETY_MESSAGE_AND_LOGO_START',
  UPDATE_SAFETY_MESSAGE_AND_LOGO_START:
    '@@UPDATE_SAFETY_MESSAGE_AND_LOGO_START',
  UPDATE_SAFETY_MESSAGE_AND_LOGO_SUCCESS:
    '@@UPDATE_SAFETY_MESSAGE_AND_LOGO_SUCCESS',
  UPDATE_SAFETY_MESSAGE_AND_LOGO_FAILURE:
    '@@UPDATE_SAFETY_MESSAGE_AND_LOGO_FAILURE',
  UPLOAD_LOGO_FAILURE: '@@UPLOAD_LOGO_FAILURE'
};

export interface SafetyMessageAndLogoState {
  submitting: boolean;
  error?: string;
  data?: string;
  safetyMessageLogo: any;
  safetyMessageLogoUpdated?: boolean;
  isNewRecordAdded?: boolean;
  type?: 'ADD' | 'EDIT'; //Default is ADD
}

export interface SafetyMessageAndLogoDataType {
  safetyMessage?: string;
  logo?: any;
  isDelete?: boolean;
}

export interface UpdateSafetyMessageAndLogoParams {
  organisationId: number;
  payload: SafetyMessageAndLogoDataType;
  params?: Params;
}

export interface LogoPayload {
  name: string;
  size: number;
  mimeType: string;
}

export interface UploadLogoParams {
  logo: LogoPayload;
  organisationId: number;
}

export interface UploadToS3Payload {
  signedUrl: string;
  logo: File;
}
